(() => {
  const toc = document.querySelector('.yp-toc');
  if (!toc) return;

  const laptopQuery = window.matchMedia('(max-width: 1199px)');

  const syncToc = () => {
    toc.open = !laptopQuery.matches;
  };

  syncToc();

  if (typeof laptopQuery.addEventListener === 'function') {
    laptopQuery.addEventListener('change', syncToc);
  } else if (typeof laptopQuery.addListener === 'function') {
    laptopQuery.addListener(syncToc);
  }
})();
